import { Tabs } from "antd";
import { ProdutoModulo } from "../../types/Produto";
import { FormProduto } from "../Form";
import { UseFormRegister } from "react-hook-form";
import { Dispatch, SetStateAction } from "react";
import EstoqueProduto from "../Estoque";


interface ProdutoModalProps {
  produto?: ProdutoModulo
  inputDisabled?: boolean
  register: UseFormRegister<any>
  errors: any
  setInputDisabled?: Dispatch<SetStateAction<boolean>>
}

export function TabsProduto({
    inputDisabled,
    produto,
    register,
    errors,
  } : ProdutoModalProps){
  return (
    <Tabs
      items={[
        {
          label: "Info. Produto",
          key: '1',
          children: (
            <FormProduto 
              produto={produto}
              visualizar
              inputDisabled={inputDisabled}
              register={register}
              errors={errors}
            />
          )
        },
        {
          label: "Estoque",
          key: '2',
          children: (
            produto && <EstoqueProduto produtoId={produto?.ProdutoId}/>

          )
        },
      ]}
    />
  )
}